/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type HeaderData } from '../interface';
import { type VehicleSummary } from '@/types';

export const getPreferredVehicle = (
  headerData: HeaderData | undefined,
): VehicleSummary | undefined => {
  // Header data still contains an object for the preferred vehicle even if none is selected
  // But the `vehicleName` and other properties are empty strings
  // So we check if it's empty don't return the dummy object in that case
  if (headerData?.vehicleMap?.vehicleId || headerData?.vehicleMap?.vehicleName) {
    return headerData.vehicleMap;
  }

  return undefined;
};
